import Scroll from 'react-scroll';
import { errorMessages } from '../constants/errorMessages';

//Dates stuff
export const getWeekdays = (weekday, rule, year) => {
    var j = 1,
    dates = [],
    x = new Date('1/1/'+year),
    y = new Date('12/31/'+year);

    if (rule == 'each') {
        for (var i = 0; x < y; i += j) {
            if (x.getDay() === +weekday) {
                dates.push(x);
                x = new Date(x.getTime() + (7 * 24 * 60 * 60 * 1000));
                j = 7;
            } else {
                j = 1;
                x = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            }
        }
    } else {
        for (var i = 0; i < 12; i++) {
            var WeekdayOfMonth = getFirstLastWeekdayOfMonth(weekday, new Date(year, i), rule);
            dates.push(WeekdayOfMonth);
        }
    }
    return dates;
}

const getFirstLastWeekdayOfMonth = (weekday, date, rule) => {
    date = new Date(date);

    if (rule == 'first') {
        var d = new Date( date.getFullYear(), date.getMonth() );
    } else {
        var d = new Date( date.getFullYear(), date.getMonth()+1, 0);
    }
    while( d.getDay() != weekday ) {
        d.setDate( d.getDate() + (rule == 'first' ? 1 : -1) );
    }
    return d;
}


export const formatIndexDate = (date, addYear) => {
    const locale = 'en-us';
    let trDate = (typeof date == 'obj') ? date : new Date(date);

    return trDate.getDate()+' '+trDate.toLocaleString(locale, { month: 'short' })+(addYear ? ' '+trDate.getFullYear() : '');
}

export const renderYearsArray = (initialYear, topupYear=0) => {
    let currentYear = (new Date()).getFullYear() + topupYear,
    years = [];
    for (let i = currentYear; i >= initialYear; i--) {
        years.push(i);
    }
    return years;
}

export const cutDate = date => date ? date.substring(0, date.indexOf('T')) : '';

export const isLaterThanWeekAfterToday = date => {
    let today = new Date(),
    weekAfterToday = today.setDate( today.getDate() + 7 );
    return (new Date(date) > weekAfterToday);
};

export const calcExpiresIn = (expiry_time, isRounded) => {
    if (expiry_time) {
        let diff = new Date(expiry_time) - new Date();
        let expiresIn = Math.round((diff/1000)/60);
        if (expiresIn >= 360) {
            return 360;
        } else if (expiresIn <= 0) {
            return 0;
        } else if (expiresIn < 22) {
            return isRounded ? 15 : expiresIn;
        } else if (expiresIn < 45) {
            return isRounded ? 30 : expiresIn;
        } else {
            return isRounded ? Math.round((expiresIn / 60))*60 : expiresIn;
        }
    }
};

//Fullscreen mode
export const toggleFullScreen = elem => {
    if (!isFullscreen()) {
        if (elem.requestFullScreen) {
            elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    } else {
      cancelFullscreen();
    }
}

export const cancelFullscreen = () => {
    if (document.cancelFullScreen) {
        document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    }
}

export function isFullscreen(){
    return !((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen));
}


//Validation helpers
export const isEveryValid = data => {
    let vals = [];
    for (const prop in data) {
        vals.push(data[prop]);
    }
    return vals.every(item => item)
}

export const firstError = data => {
    const error = Object.entries(data).find(item => !item[1]);
    return error && error[0] || false;
}

export const scrollToError = (errorField, scrollContainer) => {
    Scroll.scroller.scrollTo(errorField, { 
        duration: 200, 
        smooth: true, 
        containerId: scrollContainer || 'scroll-container', 
        offset: -50
    });
}

export const validateField = (data, fieldName, value) => {
    if (fieldName in data.validation) {
        return {
            validation: {
                ...data.validation,
                [fieldName]: value ? true : false
            }
        };
    }
}

export const isEmailValid = value => !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

export const isWWWValid = value => value == '' || !!value.match(/[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/i);

export const isIntegerValid = value => {
    const isInteger = parseInt(value) == value;
    const inRange = value >= 0 && value <= 2147483647;
    return isInteger && inRange;
}

export const isDecimalValid = value => {
    const parts = value.split('.');
    const isNumber = !isNaN(+parts[0]) && parts[1] && !isNaN(+parts[1]);
    const inRange = parts[0].length <= 16 && parts[1] && parts[1].length <= 2;
    return isNumber && inRange;
}

export const isLengthValid = (value, fieldName, model) => {
    if (model === 'company' && fieldName === 'company_name') {
        return value && value.length <= 100;
    }
    if (fieldName == 'address' ||
        fieldName == 'description') {
        return value && value.length <= 254;
    }
    if (fieldName == 'post_code' ||
        fieldName == 'whatsapp' ||
        fieldName == 'skype') {
        return value && value.length <= 25;
    }
    return value && value.length <= 50;
};

//Processing data
export const getProductsByMarketId = (marketId, products) => {
    if (!marketId) return products;
    if ( products && products.length )
        return products.filter( item => item.market_id == marketId);
}

//Processing data
export const getProductsByMarketIdAndContract = (marketId, contractTypes, products) => {
    if (!marketId) return products;
    if ( products && products.length )
        return products.filter( item => item.market_id == marketId && contractTypes.indexOf(item.contract_type) > -1);
}

//Single order helpers
export const getMonthlyQuantity = (isShort, isCustomTimeframe, props) => {
    const { trading_period_pre, units_name, quantity } = props;
    let result, pre = trading_period_pre;

    if (!quantity || !pre || isCustomTimeframe) return '';

    if (pre.indexOf('Q') != -1) {
        // result = (quantity / 3).toFixed(2);
        result = quantity;
    } else {
        return '';
    }
    return isShort ? result : `${result} ${units_name} each contract month`;
}

const isSuper = currentUser => !!currentUser.is_superuser || !!currentUser.is_admin;
export const getSingleItem = (id, arr) => arr.find( item => item.id === +id );

export const getUserTextString = (currentUser, behalfUsers, behalfUsersExtra, mode, props) => {    
    let { creator_behalf_of_id, accepted_by_behalf_of_id, creator_id, intent } = props, behalfTextString = '';
    const getSingleBehalf = (role, id) => {
        let list = role == 'creator' ? behalfUsers : behalfUsersExtra;
        return list.find( item => item.id === +id );

    }
    const isSuperUser = isSuper(currentUser);
    const accepterRole = intent === 'BUY' ? 'Seller' : 'Buyer';
    const creatorRole = intent === 'BUY' ? 'Buyer' : 'Seller';

    if (isSuperUser) {
        if (mode == 'create-finalised' || mode == 'edit-finalised') {
            const creator = getSingleBehalf('creator', creator_behalf_of_id);
            const accepter = getSingleBehalf('accepted', accepted_by_behalf_of_id);
            const creatorText = creator ? `${creatorRole} user: ${creator.username}\n${creatorRole} company: ${creator.companyname}\n` : '';
            const accepterText = accepter ? `${accepterRole} user: ${accepter.username}\n${accepterRole} company: ${accepter.companyname}\n` : '';
            behalfTextString = creatorText + accepterText;
        } else if (mode == 'success') {
            const accepter = getSingleBehalf('creator', accepted_by_behalf_of_id);
            behalfTextString = accepter ? `${accepterRole} user: ${accepter.username}\n${accepterRole} company: ${accepter.companyname}\n` : '';        
        } else {            
            const creator = getSingleBehalf('creator', creator_behalf_of_id || creator_id);
            behalfTextString = creator ? `${creatorRole} user: ${creator.username}\n${creatorRole} company: ${creator.companyname}\n` : '';
        }
    }
    return behalfTextString;
}

const parseFreights = (allFreights, freights) => {
    return allFreights
        .filter(freight => freights.indexOf(freight.id) > -1)
        .map(freight => `${freight.title}${freight.price ? ' ' + freight.currency + freight.price : ''}`).join(', ');
}

export const getPeriodForPresentation = (trading_period_prefix, trading_period) => {
    let period = '';
	if(trading_period_prefix == 'LOADED' || trading_period_prefix == 'PROMPT'){
		period = trading_period_prefix;
	}
	else
	if(trading_period_prefix == '-' || trading_period.startsWith('Q')){
		period = trading_period;
	}
	else{
		period = trading_period_prefix+' '+trading_period;
	}
	return period;
}

export const getOrderPopupText = (currentUser, currentProduct, behalfUsers, behalfUsersExtra, mode, custom_timeframe, props) => {
    let { trading_period_interval, trading_period_custom, intent, quantity, currency_id, price, type,
        trading_period, trading_period_prefix, expiry_time_left, notification_type, allFreights } = props;
        
    const behalfTextString = getUserTextString(currentUser, behalfUsers, behalfUsersExtra, mode, props);
    const monthlyQuantity = getMonthlyQuantity(true, custom_timeframe, props);
    const expiresIn = expiry_time_left ? (expiry_time_left <= 0 ? '0 minutes' : `${Math.round(expiry_time_left / 60)} minutes`) : 'Good until cancelled';
    const isSuperUser = isSuper(currentUser);
    const isPhysical = currentProduct.contract_type === 'Physical';
    const contract_type = currentProduct.contract_type;
    const units_name = currentProduct.units_name;
    const showTotal = trading_period_interval == null || (trading_period_interval.indexOf('Q') == -1) || custom_timeframe;
    const notification_type_text_arr = ['Firm', '', 'Interest', 'None'];

    return behalfTextString +
        (mode!='create-finalised' && mode!='edit-finalised' && !isSuperUser ? `Buy/Sell: ${intent}\n` : '') +
        `Quantity per month: ${quantity} ${units_name}\n` +
        (!showTotal ? `Quantity in contract: ${quantity*3} ${units_name}\n` : '') +
        `Price: ${currency_id} ${price} per ${units_name} ${!showTotal ? ' each Contract Month' : ''}\n` +
        `Product: ${currentProduct.short_name} (${contract_type}, ${units_name})\n` +
        `Period: ${custom_timeframe ? trading_period_custom : getPeriodForPresentation(trading_period_prefix, trading_period)}` +
        (mode!='create-finalised' && mode!='edit-finalised' ? `\nExpiry: ${expiresIn}` : '')+        
        (isSuperUser && type ? `\nOrder type: ${type}` : '')+
        (isSuperUser && notification_type!=undefined && type!='Regular' ? `\nNotification type: ${notification_type_text_arr[notification_type]}` : '') +
        (isPhysical && currentProduct.freights.length ? `\nFreight: ${parseFreights(allFreights, currentProduct.freights)}` : '');
}

export const getBidPopupText = (formData, currentUser, behalfUsers, behalfUsersExtra, mode) => {
    let isSuperUser = isSuper(currentUser),
    br = '\n',
    contract_type = formData.contract_type,
    isPhysical = formData.contract_type === 'Physical',
    isCME = formData.contract_type === 'CME',
    intentPrefixBefore = 'You request to '+(formData.intent=='BUY' ? (isCME ? 'OFFER' : 'SELL') : 'BUY')+br,    
    intentPrefixAfter = 'You '+(formData.intent=='BUY' ? 'sold' : 'bought')+br,
    shouldShowTotal = formData.trading_period.indexOf('Q') > -1;
    
    let successText = br + br + 'Your order has been received. A final contract will be sent by email subject mutual counterparty and credit acceptance' + br + br + 'Thank you for the business';
    let successTextCME = br + br + 'This order is subject to CMEs general rulebook' + br + br + 'Thank you';

    if(isCME) {
        successText = successTextCME;
        if (formData.intent=='BUY') {
            intentPrefixAfter = 'SELLER' + br + br;
        } else {
            intentPrefixAfter = 'BUYER' + br + br;
        }
    }


    let popupText =
        `Product: ${formData.product_short_name} (${contract_type}, ${formData.units_name})`+br+
        'Quantity per month: '+formData.quantity+' '+formData.units_name+br+
        (shouldShowTotal ? 'Quantity in contract: '+formData.quantity * 3+' '+formData.units_name+br : '')+
        'Price: '+formData.currency_id+' '+formData.price+' per '+formData.units_name+br+
        'Trading period: '+getPeriodForPresentation(formData.trading_period_prefix, formData.trading_period)+br+
        (isPhysical && formData.freights.length ? `Freight: ${parseFreights(formData.allFreights, formData.freights)}${br}` : '');

    const creatorRole = formData.intent === 'BUY' ? 'Buyer' : 'Seller';
    if (mode == 'success') {
        // Bid acceptance receipt pop-up
        if (isSuperUser) {
            const creatorText = `${creatorRole} user: ${formData.creator_name}\n${creatorRole} company: ${formData.creator_company_name}\n`;
            const accepterText = getUserTextString(currentUser, behalfUsers, behalfUsersExtra, mode, formData);
            const partiesText = formData.intent === 'BUY' ? (creatorText + accepterText) : (accepterText + creatorText);
            return partiesText + popupText + successText;
        }

        const creatorText = `${creatorRole} company: ${formData.creator_company_name}\n`;
        return intentPrefixAfter + popupText + (formData.contract_type !== 'CME' ? creatorText : '') + successText;
    } else if (mode=='success-finalised') {
        let userTextString = getUserTextString(currentUser, behalfUsers, behalfUsersExtra, 'create-finalised', formData);
        return 'Trade details as follows:\n\n' + userTextString + popupText + successText;    
    } else {
        // Confirmation pop-up
        if (isSuperUser) {
            const ceatorText = `${creatorRole} user: ${formData.creator_name}\n${creatorRole} company: ${formData.creator_company_name}\n`;
            return intentPrefixBefore + ceatorText + popupText + br;
        }

        return intentPrefixBefore + popupText;
    }
}

const shortMonthNames = trading_period => {
  return trading_period.replace('January', 'Jan').replace('February', 'Feb')
    .replace('March', 'Mar').replace('April', 'Apr').replace('June', 'Jun').replace('July', 'Jul')
    .replace('August', 'Aug').replace('September', 'Sep').replace('October', 'Oct')
    .replace('November', 'Nov').replace('December', 'Dec');
}

export const getContactEmailText = formData => {
    const { trading_period, product_short_name, type, currency_id, price, quantity, contract_type,
        unit_abbreviation, notification_type, intent } = formData;
    const mapping = {'USD': '$', 'EUR': '€', 'DKK': 'kr. ', 'NOK': 'kr. '};
        
    const isFirm = type === 'Regular' || notification_type === 0;
    const orderType = intent == 'BUY' ? 'Bid' : 'Offer';
    const isPhysical = contract_type === 'Physical';

    return `${isPhysical ? 'PHYSICAL: ' : ''}${shortMonthNames(trading_period)} - ${product_short_name} - ${isFirm ? 'Firm ' : ''} ${orderType} - ${mapping[currency_id] ? mapping[currency_id] : currency}${price} - ${quantity}${unit_abbreviation}`;
}

//Market log orderline events
export const getOrderLineElement = e => {
    const el = e.target.parentNode,
    elParent = e.target.parentNode.parentNode,
    elGrandParent = elParent.parentNode,
    isOrderLine = el => el.getAttribute('name') == 'order_line';

    return isOrderLine(el) ? el : isOrderLine(elParent) ? elParent : isOrderLine(elGrandParent) ? elGrandParent : false;
}

export const ajaxErrorsInterceptor = props => error => {
    const err = error.response;
    if (err.status.toString().indexOf('5') === 0 || err.status==417 || err.status==418 || err.status==408) {    
        if (err.status==417) {
            props.actions.instantLogout();
            props.actions.showLogin(true);
        } else if (err.status==418) {
            props.actions.instantLogout();
            props.actions.showPopup({
                title: 'Error',
                content: errorMessages['418'],
                buttonText: 'Dismiss'
            });         
        } else {
            props.actions.showPopup({
                title: 'Error',
                content: errorMessages['5xx'],
                buttonText: 'Dismiss'
            });
        }
    }

    return Promise.reject(error);
}

export const checkVersionInterceptor = props => response => {
    props.actions.checkVersion(response && response.headers && response.headers['server-revision']);
    return response;
}

export const isMobileDevice = () => {
    return !!navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini|Mobi)/i);
}

export const groupItemsBy = (items, by) => {
  const groups = (items || []).reduce((groups, item) => {
    const val = item[by];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups;
  }, {});

  return groups;
}

export const comparatorViewByOrder = (a, b) => (a.args.order > b.args.order) ? 1 : (b.args.order > a.args.order ) ? -1 : 0 


// WEBPACK FOOTER //
// ./source/services/utils.js